let $elements = $('.js-json-editor');

// https://github.com/json-editor/json-editor

setDefaultsOptions();
setDefaultsLangPhrases();


window.jsonEditorInit = function(element, editor){
	
	$(element).data('json-editor', editor);
	
	let editorinstance = $(element).data('json-editor');
	let key = 'json_editor_id_' + element.id;
	
	editor.on('ready', function(){
		
		let localStorageJSON = JSON.parse(localStorage.getItem(key));
		
		if(localStorageJSON) {
			editorinstance.setValue(localStorageJSON);
		}
		
	});
	
	editor.on('change', function(){
		
		let value = JSON.stringify(editorinstance.getValue());
		localStorage.setItem(key, value);
		
	});
	
	
};

function setDefaultsOptions() {
	
	JSONEditor.defaults.options = {...{
			'disable_collapse' : true,
			'disable_edit_json' : true,
			'disable_properties' : true,
			'prompt_before_delete' : false, // 	Если true, перед удалением узла отображается диалоговое окно с сообщением подтверждения
			'theme' : 'bootstrap5',
			'iconlib': "fontawesome5",
			'show_errors' : 'never', // Когда отображать ошибки проверки в пользовательском интерфейсе
			// 'startval' : null, // 	Заполните редактор начальным значением. Это должно соответствовать схеме редактора.
			// 'compact' : true,
		}};
	
}

function setDefaultsLangPhrases() {
	
	let defaults_lang = {
		'button_add_row_title' : "Добавить {{0}}",
		'button_delete_all_title' : "Удалить все",
		'button_delete_all' : "Удалить все",
		'button_delete_last' : "Удалить {{0}}",
		'button_delete_last_title' : "Удалить {{0}}",
		'button_delete_row_title_short' : "Удалить",
		'button_move_up_title' : "Переместить вверх",
		'button_move_down_title' : "Переместить вниз",
	};

	
	for (const [key, value] of Object.entries(defaults_lang)) {
		JSONEditor.defaults.languages.en[key] = value;
	}
	
	// JSONEditor.defaults.languages.en = {};
	
}